require('../page/attendee/modal');

class Search {

    constructor() {
        this.speakerOpen = false;
        this.changeTimer = false;
        this.year = false;
        this.init();
    }

    init = () => {
        this.items();

        $(document)
            .on('click', '[data-filter-tag] label', (e) => {
                e.preventDefault();

                var input = $(e.currentTarget).prev();

                if (input.prop('checked')) {
                    input.prop('checked', false);
                } else {
                    input.prop('checked', true);
                }

                this.change();
            })
            .on('input', '[data-search-query], [data-search-tag]', this.change)
            .on('click', '[items-list-search] [items-html-speaker]', () => {
                this.speakerOpen = true;
                $('#modalSearch').modal('hide');
            })
            .on('hidden.bs.modal', '[items-modal-speaker]', () => {
                if (this.speakerOpen) {
                    this.speakerOpen = false;
                    $('#modalSearch').modal('show');
                }
            })
            .on('click', '.search-tags-expand', (e) => {
                $(e.currentTarget).hide().prev('.fieldset').addClass('expanded');
            });
    }

    change = () => {
        if (this.isQuery()) {
            this.year = false;
            items.update('search');
        } else {
            $('[items-list-search]').hide();
        }
    }

    isQuery = () => {
        return this.getTag() != '' || this.getQuery() != '';
    }

    getQuery = () => {
        var query = $.trim($('[data-search-query]').val());
        return query.length > 2 ? query : '';
    }

    getTag = () => {
        return $('[data-search-tag]:checked').length
            ? $('[data-search-tag]:checked').val()
            : '';
    }

    filter = () => {
        var data = {};

        if (this.getQuery() != '') {
            data.query = this.getQuery();
        }

        if (this.getTag() != '') {
            data.tag = this.getTag();
        }

        return data;
    }

    html = (html, data) => {
        var words = [];

        if (this.getQuery() != '') {
            words.push(this.getQuery());
        }

        if (this.getTag() != '') {
            words.push(this.getTag());
        }

        if (words.length) {
            $.each(words, (i, word) => {
                data.name = data.name.replace(new RegExp(word, "gi"), '<strong>' + word + '</strong>');
            });

            html.find('[html="name"]').html(data.name);
        }

        if (data.type == 'Спикер') {
            html.attr({
                'items-html-speaker': data.id
            });
        }

        if (data.year == this.year) {
            html.find('[html="year"]').remove();
        } else {
            this.year = data.year;
        }

        return html;
    }

    items = () => {
        items.create({
            name: 'search',
            data: this.filter,
            html: this.html,
            onBeforePrint: response => {
                if (response.data.length > 0) {
                    items.dataOrderBy('search', 'year', 'desc');
                }
            },
            onPrint: response => {
                if (response.data.length == 0) {
                    if (this.getQuery() != '' && this.getTag() != '') {
                        $('[items-empty-search]').html('По запросу «' + this.getQuery() + '» и тегу «' + this.getTag() + '» ничего не найдено.');
                    } else if (this.getQuery() != '') {
                        $('[items-empty-search]').html('По запросу «' + this.getQuery() + '» ничего не найдено.');
                    } else if (this.getTag() != '') {
                        $('[items-empty-search]').html('По тегу «' + this.getTag() + '» ничего не найдено.');
                    }
                }
            }
        });
    }

}

new Search();